import { constants } from "../../../constants";

export default class FreeRoundsStart {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default() {
        if(this.gb.api && this.gb.api.modules && this.gb.api.modules.superWheel.instanceAvailable) {
            this.gb.api.modules.superWheel.disableWheel();
        }
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.HNR:
                event["freeSpinStarted"] = this._default;
                break;
            default:
                event["freeRoundsStart"] = this._default;
        }

        return event;
    }
}